import { render, staticRenderFns } from "./modalUploadWords.vue?vue&type=template&id=511074a5&"
import script from "./modalUploadWords.vue?vue&type=script&lang=js&"
export * from "./modalUploadWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports